import React, { useEffect, useRef, useState } from "react";
import "./style.less";
import {Link} from 'react-router-dom'

const CustomBtn = (props) => {
  const {text="",path=""} = props
  return (
    <Link to={path}><div className="custom-btn">{text}</div></Link>
  );
};

export default CustomBtn;
